'use client';

import type { FC } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { Skeleton } from '@eqi-investimentos/react';
import { PATHS } from '@/config/paths';
import { useGetAssetsOpportunities } from '@/modules/Asset/http/client/useGetAssetsOpportunities';
import { useInvest } from '@/contexts/InvestContext';
import { CardAssetRecomendation } from '@/components/molecules/CardAssetRecomendation';
import { WidgetContainer } from '@/components/molecules/Widget/Container';
export const RecommendationsWidget: FC<RecommendationsWidgetProps> = ({
  title,
  showButtonLink = true
}) => {
  const {
    selectAsset
  } = useInvest();
  const {
    t
  } = useTranslation('common');
  const {
    data: recommendations = [],
    isFetching
  } = useGetAssetsOpportunities({
    limit: 10,
    page: 1
  });
  if (!isFetching && !recommendations.length) {
    return <></>;
  }
  return <WidgetContainer containerId="recommendations" buttonLink={showButtonLink ? PATHS.hubs.recommendation : undefined} title={title ?? t('widgets.RecommendationsWidget.title')} data-sentry-element="WidgetContainer" data-sentry-component="RecommendationsWidget" data-sentry-source-file="index.tsx">
      {isFetching ? Array.from({
      length: 10
    }).map((_, idx) => <Skeleton key={idx} w="13.25rem" h="8.75rem" borderRadius="0.625rem" />) : recommendations.map(({
      id,
      ticker,
      thumb,
      recommendation,
      title,
      subcategory
    }) => <CardAssetRecomendation key={id} id={id} name={title} recommendation={translation[recommendation] ?? 'neutral'} subcategory={subcategory} thumb={thumb} ticker={ticker} handleInvestIn={asset => selectAsset({
      asset,
      openDrawer: true
    })} />)}
    </WidgetContainer>;
};
const translation = {
  COMPRA: 'buy',
  VENDA: 'sell',
  MANTER: 'keep',
  NEUTRO: 'neutral'
} as const;
type RecommendationsWidgetProps = {
  title?: string;
  showButtonLink?: boolean;
};